import "./style.css";
import maybeLogo from "../../assets/icons/maybe-logo.webp";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useUserInfo } from "../../context/user";
import SvgIcon from "../icons";
import { useNavigate } from "react-router-dom";

import { userInfo } from "os";
import { useUsersContext } from "../../context/usersContext";
import toast from "react-hot-toast";
import localforage from "localforage";
import { useAppServices } from "../../hook/services";
import ContactToSupportModal from "../ContactToSupportModal";
import ScriptRenderer from "../ScriptRenderer";
import ToastNotificationBanner from "../ToastNotificationBanner";
import TemplateChooserModal from "./AddAccount/components/TemplateChooserModal";
import CircularProgress from "@mui/material/CircularProgress";

export function Navbar() {
  const [showDropdown, setShowDropdown] = useState(false);
  const [openLimitModal, setOpenLimitModal] = useState(false);
  const navigate = useNavigate();
  const checkIfGhlUser = useUserInfo()[9];
  const pathname = window.location.pathname;
  const encryptedData = pathname.split("/")[1];
  const decryptedData = atob(encryptedData);
  const userEmail = decryptedData.split(":")[0];
  const userLocationId = decryptedData.split(":")[1];
  const checkLocation = useUserInfo()[15];
  const isValidEmail = useUserInfo()[6];
  const isValidLocationId = useUserInfo()[7];
  const userData = useUserInfo()[0];
  const agencyFromUser = useUserInfo()[11];
  const activeLocation = useUserInfo()[4];
  const { agency, isHighestPlan } = useUsersContext();
  const activeplans = useUserInfo()[12];
  const userLocations = useUserInfo()[8];
  const { setIsAuto, setSelectedAssistant, setUseAgent } = useUsersContext();
  const [userLimitReached, setUserLimitReached] = useState(false);
  const AppService = useAppServices();
  const { products } = useUsersContext();
  const [activeLocationPlan, setActiveLocationPlan] = useState<any>();
  const [showTemplateChooser, setShowTemplateChooser] = useState(false);
  const [templates, setTemplates] = useState<any[]>([]);
  const agencyData = agency && Object.keys(agency)?.length > 0 ? agency : agencyFromUser

  const appsToMap =
    activeLocation?.type === "free" ? activeLocation?.apps : activeplans?.apps;
  const changeFavicon = () => {
    // Replace 'new-favicon.ico' with the path to your new favicon
    const newFavicon = agencyData?.Customization?.chatapp_logo || "";

    // Create a new link element
    const link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/x-icon";
    link.href = newFavicon;

    // Find the existing favicon link element in the head
    const head = document.head || document.getElementsByTagName("head")[0];
    const existingFavicon = document.querySelector("link[rel*='icon']");

    // If an existing favicon is found, remove it
    if (existingFavicon) {
      head.removeChild(existingFavicon);
    }

    // Append the new favicon link element to the head
    head.appendChild(link);
  };

  useEffect(() => {
    changeFavicon();
  }, [agencyData]);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    const homeText = document.getElementById("hometext");
    if (window.location.href.includes("home") && homeText) {
      homeText.style.color = agencyData?.Customization?.topbar_active_text;
      homeText.style.fontWeight = "bold";
      // homeText.style.textShadow = " 3px 4px 4px";
      homeText.style.textDecoration = "underline";
      homeText.style.textUnderlineOffset = "5px";
    }

    const dashboardText = document.getElementById("dashboard");
    if (window.location.href.includes("dashboard") && dashboardText) {
      dashboardText.style.color = agencyData?.Customization?.topbar_active_text;
      dashboardText.style.fontWeight = "bold";
      // dashboardText.style.textShadow = " 3px 4px 4px";
      dashboardText.style.textDecoration = "underline";
      dashboardText.style.textUnderlineOffset = "5px";
    }

    const socialCalendarText = document.getElementById("socialcalendar");
    if (window.location.href.includes("calendar") && socialCalendarText) {
      socialCalendarText.style.color =
        agencyData?.Customization?.topbar_active_text;
      socialCalendarText.style.fontWeight = "bold";
      // socialCalendarText.style.textShadow = " 3px 4px 4px";
      socialCalendarText.style.textDecoration = "underline";
      socialCalendarText.style.textUnderlineOffset = "5px";
    }

    const aiAgentsText = document.getElementById("aiagents");
    if (window.location.href.includes("ai-agents") && aiAgentsText) {
      aiAgentsText.style.color = agencyData?.Customization?.topbar_active_text;
      aiAgentsText.style.fontWeight = "bold";
      aiAgentsText.style.textDecoration = "underline";
      aiAgentsText.style.textUnderlineOffset = "5px";
    }

    const taskText = document.getElementById("tasks");
    if (taskText && window.location.pathname === '/app/chat/tasks') {
      taskText.style.color = agencyData?.Customization?.topbar_active_text;
      taskText.style.fontWeight = "bold";
      taskText.style.textDecoration = "underline";
      taskText.style.textUnderlineOffset = "5px";
    } else if (taskText) {
      taskText.style.color = agencyData?.Customization?.topbar_active_text;
      taskText.style.fontWeight = "normal";
      taskText.style.textDecoration = "none";
      taskText.style.textUnderlineOffset = "0px";
    }

    const chatText = document.getElementById("chat");
    if (window.location.href.includes('/app/chat') && window.location.pathname !== '/app/chat/tasks' && chatText) {
      chatText.style.color = agencyData?.Customization?.topbar_active_text;
      chatText.style.fontWeight = "bold";
      // chatText.style.textShadow = " 3px 4px 4px";
      chatText.style.textDecoration = "underline";
      chatText.style.textUnderlineOffset = "5px";
    } else if (chatText) {
      chatText.style.color = agencyData?.Customization?.topbar_active_text;
      chatText.style.fontWeight = "normal";
      chatText.style.textDecoration = "none";
      chatText.style.textUnderlineOffset = "0px";
    }
    const settingtext = document.getElementById("setting");
    if (window.location.href.includes("setting") && settingtext) {
      settingtext.style.color = agencyData?.Customization?.topbar_active_text;
      settingtext.style.fontWeight = "bold";
      // settingtext.style.textShadow = " 3px 4px 4px";
      settingtext.style.textDecoration = "underline";
      settingtext.style.textUnderlineOffset = "5px";
    }
  }, [window.location.href]);
  const saveActiveLocation = useUserInfo()[5];
  const [selectedItem, setSelectedItem] = useState<any>(activeLocation);

  useEffect(() => {
    if (activeLocation) {
      setSelectedItem(activeLocation);
      const element = document.getElementById("appendsavelocation");
      if (element) {
        element.innerHTML = activeLocation?.business_name;
      }
    } else if (!activeLocation && userLocations.length > 0) {
      setSelectedItem(userLocations[0]);
      saveActiveLocation(userLocations[0]);
      const element = document.getElementById("appendsavelocation");
      if (element) {
        element.innerHTML = userLocations[0]?.business_name;
      }
    }
  }, [activeLocation, userLocations]);

  useEffect(() => {
    if (agencyData?.Customization?.gtag) {
      const tempContainer = document.createElement("div");
      tempContainer.innerHTML = agencyData.Customization.gtag;

      // Loop through all child nodes in the parsed HTML
      Array.from(tempContainer.childNodes).forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const element = node as HTMLElement;

          // Handle <script> tags separately (ensuring execution)
          if (element.tagName.toLowerCase() === "script") {
            const script = document.createElement("script");

            // If script has a src, load it dynamically
            if (element.getAttribute("src")) {
              script.src = element.getAttribute("src")!;
            } else {
              script.textContent = element.textContent; // Inline script execution
            }

            // Copy all attributes from original script
            Array.from(element.attributes).forEach(attr => {
              script.setAttribute(attr.name, attr.value);
            });

            document.body.appendChild(script);
          }

          // Handle <style> tags separately
          else if (element.tagName.toLowerCase() === "style") {
            const style = document.createElement("style");
            style.textContent = element.textContent;
            document.head.appendChild(style);
          }

          // Handle any other HTML elements (e.g., div, iframe)
          else {
            document.body.appendChild(element.cloneNode(true));
          }
        }
      });
    }
  }, [agencyData]);

  const handleSwicthAccount = async (location: any) => {
    saveActiveLocation(location);
    await checkLocation(
      location?.id,
      userData?.email,
      userData?.userName,
      "stand_alone"
    );
    // navigate(`/app/chatapp`)
  };
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdownd = () => setIsOpen(!isOpen);
  const handleItemClick = (item: any) => {
    setSelectedItem(item.business_name);
    setIsOpen(false);
    handleSwicthAccount(item);
    setTimeout(() => {
      const element = document.getElementById("appendsavelocation");
      if (element) {
        element.innerHTML = item.business_name;
      }
    }, 1000);
    navigate('/app/chat')
    setTimeout(() => { window.location.reload(); }, 1008)
  };

  const [videoUrl, setVideoUrl] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const getEmbedUrl = (url: string) => {
    const videoId = url.split("v=")[1]?.split("&")[0];
    return videoId ? `https://www.youtube.com/embed/${videoId}` : "";
  };

  const handleShowPopup = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => setShowPopup(false);

  const getSaaSProducts = async () => {
    try {
      const { response } = await AppService.saas.agencysaas({
        query: `agency_id=${activeLocation?.agency_id}`,
      });
      if (response?.data) {
        setActiveLocationPlan(
          response?.data?.filter(
            (item: any) => item._id === activeLocation.plan_id
          )[0]
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getSaaSProducts();
  }, []);

  const handleNavigate = async () => {

    if (
      userLocations.length - 1 >=
      activeLocation.number_of_additional_accounts &&
      activeLocation?.type === "free"
    ) {
      setUserLimitReached(true);
      return;
    }

    const currentAdditionalAccounts = userLocations.length - 1;
    const maxAdditionalAccounts = activeLocationPlan?.additional_accounts || 0;

    if (currentAdditionalAccounts >= maxAdditionalAccounts) {
      setUserLimitReached(true);
      return;
    }

    const agencyIdForTemplates =
      (activeLocation as any)?.agency_id ||
      (agencyData as any)?._id ||
      (userData as any)?.agency_id;

    if (agencyIdForTemplates) {
      const { response } = await AppService.free_account_template.get({
        query: `agency_id=${agencyIdForTemplates}&page=1&limit=100`,
        toaster: false,
      });
      if (response) setTemplates(response.data || []);
    }
    setShowTemplateChooser(true);
  };

  const handleTemplateChoice = (template: any) => {
    setShowTemplateChooser(false);
    navigate("/app/add-account-setup", {
      state: { templateData: template },
    });
  };

  useEffect(() => {
    const activePlan = products?.find((item: any) => item?.activePlan === true)
    if (userLimitReached) {
      setTimeout(() => {
        if (activeLocation?.type === 'free' || (!activePlan?.isenable_account && !activePlan?.developer_plan) || isHighestPlan())
          setOpenLimitModal(true)
        else
          navigate("/app/settings", {
            state: { tab: "Pricing", text: "Upgrade to add more workspaces" },
          });
      }, 500);
    }
  }, [userLimitReached]);

  return (
    <div
      className="topHeaderAgency"
      style={{
        background: agencyData?.Customization?.topbar_bg
          ? agencyData?.Customization?.topbar_bg
          : "#fff",
      }}
    >
      <div className="navmenu">
        {/* {!checkIfGhlUser && ( */}
        <div className="logo">
          {/* <img src={agencyData?.Customization?.logo || maybeLogo} alt="" /> */}
          {agencyData?.Customization?.logo ? (
            <img src={agencyData?.Customization?.logo} alt="" />
          ) : <SvgIcon id="maybeIcon" />}
        </div>
        {/* )} */}
        <div className="groupBtn-z">
          {agencyData?.Customization?.newsfeedshow && (
            <Link
              id="hometext"
              to={
                isValidEmail(userEmail) && isValidLocationId(userLocationId)
                  ? `/${btoa(`${userEmail}:${userLocationId}`)}/app/home`
                  : "/app/home"
              }
              style={{
                background: agencyData?.Customization?.button_bg
                  ? agencyData?.Customization?.button_bg
                  : "#fff",
                color: agencyData?.Customization?.button_text
                  ? agencyData?.Customization?.button_text
                  : "#000",
                borderColor: agencyData?.Customization?.button_border
                  ? agencyData?.Customization?.button_border
                  : "#000",
              }}
            >
              News
            </Link>
          )}
          {/* {appsToMap?.map((item: any) => ( */}
          <>
            {/* {item === "AI Celender App" && <>
                <Link id="socialcalendar" to={isValidEmail(userEmail) && isValidLocationId(userLocationId) ? `/${btoa(`${userEmail}:${userLocationId}`)}/app/calendar` : "/app/calendar"} className="dropdown-toggle" style={{ background: agencyData?.Customization?.button_bg ? agencyData?.Customization?.button_bg : '#fff', color: agencyData?.Customization?.button_text ? agencyData?.Customization?.button_text : '#000', borderColor: agencyData?.Customization?.button_border ? agencyData?.Customization?.button_border : '#000' }}>
                  Content Calendar
                </Link>
              </>} */}
            {/* {item === "AI Social App" && ( */}


            <>
              <p
                id="chat"
                onClick={() => {
                  setIsAuto(true);
                  setUseAgent(false);
                  setSelectedAssistant(null);
                  (!window.location.pathname?.includes('/app/chat') || window.location.pathname === '/app/chat/tasks' || window.location.pathname === '/app/chat/search') && navigate(isValidEmail(userEmail) && isValidLocationId(userLocationId)
                    ? `/${btoa(`${userEmail}:${userLocationId}`)}/app/chat`
                    : "/app/chat")
                }}
                className="dropdown-toggle"
                style={{
                  background: agencyData?.Customization?.button_bg
                    ? agencyData?.Customization?.button_bg
                    : "#fff",
                  color: agencyData?.Customization?.button_text
                    ? agencyData?.Customization?.button_text
                    : "#000",
                  borderColor: agencyData?.Customization?.button_border
                    ? agencyData?.Customization?.button_border
                    : "#000",
                }}
              >
                Your Tasks
              </p>
            </>



            {/* )} */}
          </>
          {/* ))} */}

          <div
            onClick={() => navigate(isValidEmail(userEmail) && isValidLocationId(userLocationId)
              ? `/${btoa(`${userEmail}:${userLocationId}`)}/app/chat/tasks`
              : "/app/chat/tasks")}
            id='tasks'
            style={{
              background: agencyData?.Customization?.button_bg
                ? agencyData?.Customization?.button_bg
                : "#fff",
              color: agencyData?.Customization?.button_text
                ? agencyData?.Customization?.button_text
                : "#000",
              borderColor: agencyData?.Customization?.button_border
                ? agencyData?.Customization?.button_border
                : "#000",
            }}
            className="ml-4 cursor-pointer"
          >
            All Tasks
          </div>


          <Link
            id="aiagents"
            to={
              isValidEmail(userEmail) && isValidLocationId(userLocationId)
                ? `/${btoa(`${userEmail}:${userLocationId}`)}/app/ai-agents`
                : "/app/ai-agents"
            }
            className="dropdown-toggle"
            style={{
              background: agencyData?.Customization?.button_bg || "#fff",
              color: agencyData?.Customization?.button_text || "#000",
              borderColor: agencyData?.Customization?.button_border || "#000",
            }}
          >
            AI Agents
          </Link>

          <Link
            id="setting"
            to={
              isValidEmail(userEmail) && isValidLocationId(userLocationId)
                ? `/${btoa(`${userEmail}:${userLocationId}`)}/app/settings`
                : "/app/settings"
            }
            style={{
              background: agencyData?.Customization?.button_bg
                ? agencyData?.Customization?.button_bg
                : "#fff",
              color: agencyData?.Customization?.button_text
                ? agencyData?.Customization?.button_text
                : "#000",
              borderColor: agencyData?.Customization?.button_border
                ? agencyData?.Customization?.button_border
                : "#000",
            }}
            className="!mx-1"
          >
            Configure
          </Link>
        </div>
      </div>

      {
        agencyData?.Customization?.video_text && (
          <div className="group hover:bg-[#3647FF] bg-white border !border-[#D9D9D9] rounded transition duration-200 !ease-in-out py-[5px]">
            <button
              onClick={handleShowPopup}
              className="video-popup__button group-hover:!text-white !transition !duration-200 !ease-in-out"
              style={{ display: "flex", gap: "8px", width: 'fit-content', whiteSpace: "nowrap", background: 'transparent' }}
            >
              <div>
                <SvgIcon id="AIAcademyIcon" classNames={'group-hover:fill-white !transition !duration-200 !ease-in-out'} />
              </div>

              {agencyData?.Customization?.video_text && (
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      agencyData.Customization.video_text.length > 20
                        ? `${agencyData.Customization.video_text.slice(0, 20)}...`
                        : agencyData.Customization.video_text,
                  }}
                />
              )}
            </button>

            {showPopup && (
              <div className="video-popup__overlay">
                <div
                  className="video-popup__content"
                  style={{ minHeight: "300px" }}
                >
                  <button
                    onClick={handleClosePopup}
                    style={{
                      color: "black",
                      fontSize: "20px",
                    }}
                    className="video-popup__close"
                  >
                    x
                  </button>
                  {agencyData.Customization.video_link.includes("iframe") ? (
                    <IframeExtractor
                      content={agencyData.Customization.video_link}
                      targetId="iframeContainer"
                    />
                  ) : agencyData.Customization.video_link.includes("script") ? (
                    <ScriptRenderer html={agencyData.Customization.video_link} />
                  ) : (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: agencyData.Customization.video_link,
                      }}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        )
      }

      <div className="groupBtn-z-r">
        {!checkIfGhlUser && (
          <div
            style={{ width: "80%", position: "relative", marginRight: "30px" }}
          >
            <div
              style={{
                padding: "12px 9px",
                border: "1px solid #d9d9d9",
                borderRadius: "5px",
                backgroundColor: "white",
                fontSize: "16px",
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={toggleDropdownd}
            >
              <span
                style={{
                  width: "85%",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  textAlign: "left",
                }}
                id="appendsavelocation"
              >
                {selectedItem ? selectedItem?.business_name : "Switch Account"}
              </span>
              <span
                style={{
                  marginLeft: "10px",
                  width: "10px",
                  height: "10px",
                  borderLeft: "2px solid black",
                  borderBottom: "2px solid black",
                  transform: isOpen ? "rotate(135deg)" : "rotate(-45deg)",
                  transition: "transform 0.2s ease",
                }}
              ></span>
            </div>
            {isOpen && (
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  maxHeight: "200px",
                  overflowY: "auto",
                  border: "1px solid #d9d9d9",
                  borderRadius: "5px",
                  backgroundColor: "white",
                  zIndex: 1000,
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                  marginTop: "10px",
                }}
              >
                {userLocations.length > 0 &&
                  userLocations.map((item: any, index: number) => (
                    <div
                      key={index}
                      style={{
                        padding: "10px",
                        cursor: "pointer",
                        textAlign: "left",
                      }}
                      onClick={() => handleItemClick(item)}
                    >
                      {item.business_name}
                    </div>
                  ))}

                {userData?.role === "admin" && userLocations.length > 0 ? (
                  <div
                    style={{
                      padding: "10px",
                      cursor: "pointer",
                      textAlign: "left",
                    }}
                    onClick={() => handleNavigate()}
                  >
                    Add Workspace +
                  </div>
                ) : (<div className="w-full flex items-center justify-center min-h-[50px]"><CircularProgress size={20} /></div>)}
              </div>
            )}
          </div>
        )}
      </div>
      <ContactToSupportModal isOpen={openLimitModal} onClose={() => setOpenLimitModal(false)} />
      <TemplateChooserModal
        open={showTemplateChooser}
        onClose={() => setShowTemplateChooser(false)}
        templates={templates}
        onContinue={handleTemplateChoice}
      />
      {agencyData?.notifications?.length > 0 && <ToastNotificationBanner agency={agencyData} user={userData} />}
    </div >
  );
}

const IframeExtractor = ({
  content,
  targetId,
}: {
  content: string;
  targetId: string;
}) => {
  useEffect(() => {
    // Function to decode HTML entities
    const decodeHtml = (html: string): string => {
      const textarea = document.createElement("textarea");
      textarea.innerHTML = html;
      return textarea.value;
    };

    const extractIframeSrc = (htmlString: string): string | null => {
      const decodedHtml = decodeHtml(htmlString); // Decode before extracting
      const match = decodedHtml.match(/<iframe[^>]+src=["']([^"']+)["']/);
      return match ? match[1] : null;
    };

    const iframeSrc = extractIframeSrc(content);
    if (iframeSrc) {
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.innerHTML = ""; // Clear previous content
        const iframe = document.createElement("iframe");
        iframe.src = iframeSrc;
        iframe.width = "560";
        iframe.height = "315";
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute(
          "allow",
          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        );
        iframe.setAttribute("allowfullscreen", "true");
        targetElement.appendChild(iframe);
      }
    }
  }, [content, targetId]);

  return <div id={targetId}></div>;
};
